import { render, staticRenderFns } from "./PagePart_edit.vue?vue&type=template&id=df419452&scoped=true"
import script from "./PagePart_edit.vue?vue&type=script&lang=js"
export * from "./PagePart_edit.vue?vue&type=script&lang=js"
import style0 from "./PagePart_edit.vue?vue&type=style&index=0&id=df419452&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df419452",
  null
  
)

export default component.exports